import { apiClient, ApiClientConfig } from 'api';

export const ExpensesApiService = () => {
  const getExpensesReport = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_BASE_V2_URL;

    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/facilityexpenses`,
      params,
    });

    return response.data;
  };
  const createReportExpenses = async (payload: any) => {
    const baseURL = process.env.REACT_APP_BASE_V2_URL;
    const response = await apiClient({
      endpoint: `${baseURL}/facilityexpenses`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const getDropDownReport = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const baseURL = process.env.REACT_APP_BASE_V2_URL;
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/dropdownlist`,
      params,
    });

    return response.data;
  };

  return {
    getExpensesReport,
    createReportExpenses,
    getDropDownReport,
  };
};
